/**
 * Български надписи за компонентите на PrimeVue.
 *
 * Слива се върху вградената локализация след инсталирането на приставката, за
 * да не изчезнат ключовете, които не превеждаме.
 */
export const bgLocale = {
  startsWith: 'Започва с',
  contains: 'Съдържа',
  notContains: 'Не съдържа',
  endsWith: 'Завършва с',
  equals: 'Равно на',
  notEquals: 'Различно от',
  noFilter: 'Без филтър',
  lt: 'По-малко от',
  lte: 'По-малко или равно на',
  gt: 'По-голямо от',
  gte: 'По-голямо или равно на',
  dateIs: 'Датата е',
  dateIsNot: 'Датата не е',
  dateBefore: 'Преди',
  dateAfter: 'След',
  clear: 'Изчисти',
  apply: 'Приложи',
  matchAll: 'Всички условия',
  matchAny: 'Поне едно условие',
  addRule: 'Добави условие',
  removeRule: 'Премахни условие',
  accept: 'Да',
  reject: 'Не',
  choose: 'Избери',
  upload: 'Качи',
  cancel: 'Откажи',
  completed: 'Завършено',
  pending: 'Изчаква',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'],
  dayNamesShort: ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
  dayNamesMin: ['н', 'п', 'в', 'с', 'ч', 'п', 'с'],
  monthNames: [
    'януари',
    'февруари',
    'март',
    'април',
    'май',
    'юни',
    'юли',
    'август',
    'септември',
    'октомври',
    'ноември',
    'декември',
  ],
  monthNamesShort: [
    'яну',
    'фев',
    'мар',
    'апр',
    'май',
    'юни',
    'юли',
    'авг',
    'сеп',
    'окт',
    'ное',
    'дек',
  ],
  chooseYear: 'Избери година',
  chooseMonth: 'Избери месец',
  chooseDate: 'Избери дата',
  prevDecade: 'Предишно десетилетие',
  nextDecade: 'Следващо десетилетие',
  prevYear: 'Предишна година',
  nextYear: 'Следваща година',
  prevMonth: 'Предишен месец',
  nextMonth: 'Следващ месец',
  prevHour: 'Предишен час',
  nextHour: 'Следващ час',
  prevMinute: 'Предишна минута',
  nextMinute: 'Следваща минута',
  prevSecond: 'Предишна секунда',
  nextSecond: 'Следваща секунда',
  am: 'преди обяд',
  pm: 'след обяд',
  today: 'Днес',
  weekHeader: 'Сед',
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: 'dd.mm.yy',
  weak: 'Слаба',
  medium: 'Средна',
  strong: 'Силна',
  passwordPrompt: 'Въведете парола',
  emptyFilterMessage: 'Няма съвпадения',
  searchMessage: 'Има още резултати — уточнете търсенето',
  selectionMessage: '{0} избрани',
  emptySelectionMessage: 'Няма избран запис',
  emptySearchMessage: 'Няма съвпадения',
  fileChosenMessage: '{0} файла',
  noFileChosenMessage: 'Няма избран файл',
  emptyMessage: 'Няма данни',
  aria: {
    trueLabel: 'Да',
    falseLabel: 'Не',
    nullLabel: 'Не е избрано',
    star: '1 звезда',
    stars: '{star} звезди',
    selectAll: 'Избери всички',
    unselectAll: 'Отмени избора',
    close: 'Затвори',
    previous: 'Назад',
    next: 'Напред',
    navigation: 'Навигация',
    scrollTop: 'Към началото',
    moveTop: 'Премести най-горе',
    moveUp: 'Премести нагоре',
    moveDown: 'Премести надолу',
    moveBottom: 'Премести най-долу',
    moveToTarget: 'Премести надясно',
    moveToSource: 'Премести наляво',
    moveAllToTarget: 'Премести всички надясно',
    moveAllToSource: 'Премести всички наляво',
    pageLabel: 'Страница {page}',
    firstPageLabel: 'Първа страница',
    lastPageLabel: 'Последна страница',
    nextPageLabel: 'Следваща страница',
    prevPageLabel: 'Предишна страница',
    rowsPerPageLabel: 'Записи на страница',
    jumpToPageDropdownLabel: 'Към страница',
    jumpToPageInputLabel: 'Към страница',
    selectRow: 'Избери реда',
    unselectRow: 'Отмени избора на реда',
    expandRow: 'Разгъни реда',
    collapseRow: 'Сгъни реда',
    showFilterMenu: 'Покажи филтъра',
    hideFilterMenu: 'Скрий филтъра',
    filterOperator: 'Оператор',
    filterConstraint: 'Условие',
    editRow: 'Редактирай реда',
    saveEdit: 'Запиши',
    cancelEdit: 'Откажи',
    listView: 'Списък',
    gridView: 'Мрежа',
    slide: 'Кадър',
    slideNumber: 'Кадър {slideNumber}',
    zoomImage: 'Увеличи',
    zoomIn: 'Приближи',
    zoomOut: 'Отдалечи',
    rotateRight: 'Завърти надясно',
    rotateLeft: 'Завърти наляво',
    listLabel: 'Списък с опции',
  },
}
